export const powerSlideConfig = {
  theme: 'power-slide', // nova-theme, basic-theme
  components: {
    amount: 'revert-convert', // 'basic', 'slider', 'revert-convert'
    error: 'bottom', // top, bottom
  },
};
